module.exports = __webpack_public_path__ + "static/media/logo.998b2a27.png";